import { defineMessages } from 'react-intl';

export default defineMessages({
    trailerMonetaryValue: {
        id: 'wmic-pe-capability-gateway-common-ho-react.WMICHOTrailerInfoDetails.Value',
        defaultMessage: 'Value',
    },
});
